jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });

});

$(window).on('scroll', function () {
  if ($(this).scrollTop() > 30) {
    $('#shopify-section-header_top').addClass('topsticky');
  } else {
    $('#shopify-section-header_top').removeClass('topsticky');
  }
});

jQuery( document ).ready(function() {
  
	// Show the first tab by default
jQuery('.tabs-stage div').hide();
jQuery('.tabs-stage div:first').show();
jQuery('.tabs-nav div:first').addClass('tab-active');

// Change tab class and display content
jQuery('.tabs-nav a').on('click', function(event){
  event.preventDefault();
  jQuery('.tabs-nav div').removeClass('tab-active');
  jQuery(this).parent().addClass('tab-active');
  jQuery('.tabs-stage div').hide();
  jQuery(jQuery(this).attr('href')).show();
});

    jQuery('.years .tab-menu li a').on('click', function () {
      var target = jQuery(this).attr('data-rel');
      jQuery('.years .tab-menu li a').removeClass('active');
      jQuery(this).addClass('active');

      jQuery("#" + target).fadeIn('slow').siblings(".years .tab-main-box .tab-box").hide();
      return false;
    });
    jQuery('.tab-main-box .tab-box').hide();
    jQuery('.tab-main-box .tab-box:first-child').show();
    jQuery('.tab-menu li:first-child a').addClass('active');
    jQuery('.years .tab-main-box .tab-box.tab-1').addClass('active');
  
$("#revcarousel").owlCarousel({
  autoplay: true,
  rewind: false, /* use rewind if you don't want loop */
  margin: 20,
  loop: true,
  responsiveClass: true,
  autoHeight: true,
  autoplayTimeout: 7000,
  smartSpeed: 800,
  nav: false,
  dots:false,
  navText: [
    '<svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
    '<svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
  responsive: {
    0: {
      stagePadding: 32,
      items: 1
    },

    600: {
 stagePadding: 32,
      items: 2
    },

    1024: {
      items: 3
    },

    1366: {
      items: 3
    }
  }
});


function removeit_mobile() {
    if ($(window).width() > 767) {
     $('.mobile-add-to-cart').remove();
    }
}
$(function() {
    removeit_mobile();
});

  function removeit_desktop() {
    if ($(window).width() < 767) {
     $('.product-infors').remove();
    }
}
$(function() {
    removeit_desktop();
});


    $( ".cstm-menu-new .menu-no-links span.open-sub" ).each(function() {
    $(this).on("click", function(){
      $('.cstm-menu-new .menu-no-links').removeClass('active-main');
      $('.selected-items .mega-menu_second').removeClass("second-sub2").hide();
       $('.sub-menus .cstm-sel-menu .submenu_header .closebtn2').show();
      $('.cstm-menu-new .sub-menus .menu_button_global.second').show();
        $(this).closest('.cstm-menu-new').find('.menu-no-links').addClass('active-main');
      $('.sub-menus').removeClass("active-sub").hide();
        $(this).closest(".cstm-menu-new").find('.sub-menus').show().toggleClass("active-sub");
$('a.closebtn').hide(); 
    });
});

$('.new-drawer-menu').hide(); 
$(".custom-menu-toggle").click(function(){
        $(this).addClass('active');
        $('.new-drawer-menu').show(); 
});
$(".closebtn").click(function(){
        $("custom-menu-toggle").removeClass('active');
        $('.new-drawer-menu').hide(); 
});

$( "span.child-menu-new img" ).each(function() {
    $(this).on("click", function(){
      $('.child-menu-new').removeClass('active-main2')
        $(this).closest('.main-child2').find('.child-menu-new').addClass('active-main2');
        // $('.grand-child-menu').removeClass("active-sub").hide();
        //$(".grand-child-menu").show().toggleClass("active-sub"); 
      $('.grand-child-menu').removeClass('active-sub2').hide();
       $(this).closest('.main-child2').find(".grand-child-menu").show().addClass('active-sub2');
      $('a.secondclosebtn').hide();
      $(".menu_button_global.third").hide();
    });
});

$( ".selected-list .selected-items .second-menu" ).each(function() {
    $(this).on("click", function(){
      $('.second-menu').removeClass('second-active2');
      $(this).addClass('second-active2');
      $('.mega-menu_second').removeClass('second-sub2');
      $('.mselected-items').removeClass('second-sub2').hide();
      $('.selected-items .mega-menu_second').removeClass('second-sub2').hide();
      $('.main-child2 .grand-child-menu').removeClass('active-sub2').hide();
      $('.selected-items .mega-menu_second .menu_button_global.third').show();
      $('.selected-items .mega-menu_second .mega-menu__list .main-child2 span').removeClass('active-main2');
      $('.selected-items .mega-menu_second .secondclosebtn').show();
       $(this).closest('.selected-items').find(".mega-menu_second").show().addClass('second-sub2');
      $('a.closebtn2').hide();
      $(".menu_button_global.second").hide();
    });
});
$("a.secondclosebtn").click(function(){
        $('.mega-menu_second').removeClass('second-sub2').hide();
        $('.second-menu').removeClass('second-active2');
        $('a.closebtn2').show();
        $(".menu_button_global.second").show();
});
$("a.closebtn2").click(function(){
        $('.sub-menus').removeClass('active-sub').hide();
        $('.menu-no-links').removeClass('active-main');
    $('a.closebtn').show();
});
$("a.grandclosebtn").click(function(){
        $('.grand-child-menu').removeClass('active-sub2').hide();
        $('.child-menu-new').removeClass('active-main2');
    $('a.secondclosebtn').show();
    $(".menu_button_global.third").show();
});

$(".row.al_center .custom-menu-toggle").click(function(){
        $('body').addClass('menu_open_cstm');
    $('div#shopify-section-new-menu-design').show();
});
$("a.closebtn").click(function(){
        $('body').removeClass('menu_open_cstm');
    $('div#shopify-section-new-menu-design').hide();
});

$(".menu-all-close>a").click(function(){
  $('body').removeClass('menu_open_cstm');
  $('a.closebtn').show();
    $('div#shopify-section-new-menu-design').hide();
  $('.grand-child-menu').removeClass('active-sub2').hide();
        $('.child-menu-new').removeClass('active-main2');
  $('.sub-menus').removeClass('active-sub').hide();
        $('.menu-no-links').removeClass('active-main');
  $('.mega-menu_second').removeClass('second-sub2').hide();
        $('.second-menu').removeClass('second-active2');
});
  

jQuery(document).on('click', function(event) {
    // Check if the click was outside the specified elements
    if (!$(event.target).closest('#MegaMenu-Content-1').length && 
        !$(event.target).closest('.custom-menu-toggle').length && 
        !$(event.target).closest('.new-drawer-menu').length && 
        !$(event.target).closest('.sub-menus.active-sub').length && 
        !$(event.target).closest('.mega-menu_second.second-sub2').length && 
        !$(event.target).closest('.grand-child-menu.active-sub2').length) {
        
        // Perform your actions if the click is outside all excluded elements
        $('body').removeClass('menu_open_cstm');
        $('a.closebtn').show();
        $('div#shopify-section-new-menu-design').hide();
        $('.grand-child-menu').removeClass('active-sub2').hide();
        $('.child-menu-new').removeClass('active-main2');
        $('.sub-menus').removeClass('active-sub').hide();
        $('.menu-no-links').removeClass('active-main');
        $('.mega-menu_second').removeClass('second-sub2').hide();
        $('.second-menu').removeClass('second-active2');
    }
});


});



//homepage tabbing section
jQuery(document).ready(function($) {
    setInterval(function() {
        $('.js_t4_tab').on('click', function(e) {
            e.preventDefault();

            var blockId = $(this).data('bid'); // Get the block ID from the clicked tab
            console.log("Tab clicked, block ID: " + blockId);

            // Remove active class from all tabs and content
            $('.js_t4_tab').removeClass('tt_active');
            $('.tab_se_element').removeClass('ct_active').hide();

            // Add active class to the clicked tab and display corresponding content
            $(this).addClass('tt_active');
            $('#tab_' + blockId).addClass('ct_active').show();
        });
    }, 200); // 200ms = 0.2 seconds
});
